import {useState, useContext} from "react";
import { UserContext } from '../Context/UserContext';
import "../styles/userSettings.css"
import SignupLoginButtons from "./SignupLoginButtons";

function UserSettings() {
    const {state, dispatch} = useContext(UserContext);
    const [seeCurrentEmail, setSeeCurrentEmail] = useState(false)
    const [changeEmail, setChangeEmail] = useState(false)
    const [newEmail, setNewEmail] = useState('')
    const [confirmNewEmail, setConfirmNewEmail] = useState('')
    const [errors, setErrors] = useState('')
    const [message, setMessage] = useState('')
    const subType = state.user?.subscription?.sub_type
    const subStatus = state.user?.subscription?.status
    const [showCancelModal, setShowCancelModal] = useState(false)
    //console.log('user', state.user)

    function toggleCurrentEmail() {
        setSeeCurrentEmail(!seeCurrentEmail)
    }

    function toggleChangeEmail() {
        setChangeEmail(!changeEmail)
    }

    function handleChange(e) {
        const {name, value} = e.target
        if (name === "newEmail") setNewEmail(value)
        if (name === "confirmNewEmail") setConfirmNewEmail(value)
    }

    function handleSubmit(e) {
        e.preventDefault()
        if (newEmail !== confirmNewEmail) {
            setErrors("Emails do not match")
        }
        else {
            fetch(`/users/${state.user.id}/update_email`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user_id: state.user.id,
                    new_email: newEmail
                })
            })
            .then(res => res.json())
            .then(data => {
                if (!data.errors) {
                    setNewEmail('')
                    setConfirmNewEmail('')
                    setErrors('')
                    setMessage("Email updated successfully")
                    dispatch({type: 'setUser', payload: data})
                }
                else {
                    setErrors(data.error)
                }
            }
        )}
    }

    function handleCancelSub() {
        setShowCancelModal(true)
        setMessage('')
        setErrors('')
    }

    function handleConfirmCancel() {
        fetch(`/users/${state.user.id}/cancel_subscription`, {
            method: "POST",
            headers: {
                "Content-Type" : "application/json"
            },
            body: JSON.stringify({
                user_id: state.user.id
            }),
        })
        .then(res => res.json)
        .then((data) => {
            if (!data.errors) {
                setMessage(data.message)
                dispatch({type: 'setUser', payload: data})
            }
            else {
                setErrors(data.error)
            }
        })
        .catch((err) => {
            setErrors("An error occured while canceling your subscription")
        })
        setShowCancelModal(false)
    }

    function handleCancelModalClose() {
        setShowCancelModal(false)
    }

    return (
        <div className="userSettings">
            {!state.loggedIn && (
                <div>
                    <h2>Successfully logged out.</h2>
                    <SignupLoginButtons />
                </div>
            )}
            {state.loggedIn && (
                <div>
                    <h2>Welcome, {state.user?.first_name}</h2>
                    <button onClick={toggleCurrentEmail}>{seeCurrentEmail ? "Hide Current Email" : "See Current Email"}</button>
                    <br />
                    {seeCurrentEmail && <p>Current Email: {state.user?.email}</p>}
                    <br />
                    <button onClick={toggleChangeEmail}>{changeEmail ? "Cancel Email Change" : "Change Email?"}</button>
                    <br />
                </div>)}
            {changeEmail && (
                <div className="changeEmailForm">
                    <p>Make sure you have access to your new email. It is how you will login and how we will communicate with you.</p>
                    <form onSubmit={handleSubmit}>
                        <label>New Email: </label>
                        <br />
                        <input type="email" id="newEmail" name="newEmail" value={newEmail} onChange={handleChange} required></input>
                        <br />
                        <label>Confirm New Email: </label>
                        <br />
                        <input type="email" id="confirmNewEmail" name="confirmNewEmail" value={confirmNewEmail} onChange={handleChange} required></input>
                        <br />
                        <button type="submit">Save Changes</button>
                    </form>
                    {message && <p style={{color: "blue"}}>{message}</p>}
                    {errors && <p className="errors">{errors}</p>}
                </div>
            )}
            <br />
            {subStatus === true && subType === "Monthly Pass" && (<p>Please email: contactbattersbox@gmail.com to cancel your subscription</p>)}
            {/* {subStatus === true && subType === "Monthly Pass" && (<button onClick={handleCancelSub}>Cancel Subscription</button>)}
            {message && <p style={{color: "blue"}}>{message}</p>} */}
            {/* {showCancelModal && (
                <div className="cancelPopUP">
                    <div className="cancelPopUpContent">
                    <p>Are you sure you want to cancel your subscription?</p>
                    <div className="cancelButtons">
                        <button onClick={handleConfirmCancel}>Yes, Cancel Subscription</button>
                        <button onClick={handleCancelModalClose}>No, Keep Subscription</button>
                    </div>
                    </div>
                </div>
            )} */}
        </div>
    )
}

export default UserSettings